import * as Cesium from 'cesium';
import CONSTANTS from "../constants";
import $ from 'jquery';
export default {
    /**
     * 初始化视图位置
     */
    initView(){
        const angleView=CONSTANTS.initViewConfig;
        window.viewer&&this.flyTo(angleView.longitude,angleView.latitude,angleView.height,angleView.heading,angleView.pitch,angleView.roll);
    },

    /**
     * 设置冒泡
     * @param {*} overlay
     */
    setOverlay(overlay){
        this.overlay=overlay;
    },

    /**
     * 关闭冒泡
     */
    closeOverlay(){
        this.overlay&&this.overlay.close();
    },
    /**
     * 打开冒泡弹框
     */
    openOverlay(entity){
        let self=this;
        if(entity.attributes&&entity.attributes.layerName){
            $('#popupInfo').html(this.getOverlayContent(entity.attributes));
            $('.leaflet-popup-close-button').click(function () {//关闭冒泡弹框
                self.closeOverlay();
            });
            if(this.overlay&&entity.attributes.longitude&&entity.attributes.latitude){
                this.overlay.setPosition(Cesium.Cartesian3.fromDegrees(entity.attributes.longitude,entity.attributes.latitude));
                this.overlay.show();
            }
        }
    },

    /**
     * 冒泡信息框内容处理
     * layerName是分类
     * @param {*} data
     */
    getOverlayContent(attributes){
        let content="";
        let bottomBtn='<div class="info-bottom" style="position: relative; top: -9px; margin: 0px auto;"><img style="margin-left: 48%;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAMAAADHqI+lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNCMTZENDU2NkNEMTExRUFCNTNFOTdERjU1MEJGOEVFIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNCMTZENDU3NkNEMTExRUFCNTNFOTdERjU1MEJGOEVFIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0IxNkQ0NTQ2Q0QxMTFFQUI1M0U5N0RGNTUwQkY4RUUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0IxNkQ0NTU2Q0QxMTFFQUI1M0U5N0RGNTUwQkY4RUUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7jIeW+AAAAD1BMVEV4eHi7u7u6urq5ubn////udRiHAAAABXRSTlP/////APu2DlMAAAA0SURBVHjaVMjJDQAwCMRADvdfc7IhCOGfx9JWaSxJDGI+EIzcf9CiL8D1zoCkvgH/zxFgAC97AP+bBgXCAAAAAElFTkSuQmCC"></div>';
        switch (attributes.layerName) {
            case CONSTANTS.LAYER.WORKER://工作员
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">工作员</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    <span class="p_label">姓名:</span><span class="p_value">${attributes.name}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label">卡号:</span><span class="p_value">${attributes.positioningDeviceNumber}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label">手机:</span><span class="p_value">${attributes.phone}</span>
                                </div>
                                <div class="p_line">
                                    <button class="popup-buttton" onclick='window.EventCenter.emit("openDetail", ${JSON.stringify(attributes)})'>查看档案详情</button>
                                    <button class="popup-buttton" onclick='window.EventCenter.emit("openTrack", ${JSON.stringify(attributes)})'>轨迹</button>
                                </div>
                                
                            </div>
                         </div>`;
                break;
            case CONSTANTS.LAYER.VEHICLE://车辆
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">车辆</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    <span class="p_label">车牌号:</span><span class="p_value" title="DH-20220725-0001">${attributes.licensePlate}</span>
                                </div>
                                 <div class="p_line">
                                    <span class="p_label">手机:</span><span class="p_value">${attributes.phone}</span>
                                </div>
                                <div class="p_line">
                                    <button class="popup-buttton" onclick='window.EventCenter.emit("openDetail", ${JSON.stringify(attributes)})'>详细信息</button>
                                    <button class="popup-buttton" onclick='window.EventCenter.emit("openTrack", ${JSON.stringify(attributes)})'>轨迹</button>
                                </div>
                                
                            </div>
                         </div>`;
                break;
            case CONSTANTS.LAYER.CAMERA://摄像头
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">监控探头</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    <span class="p_label" title="编号">编号:</span><span class="p_value" title="DH-20220725-0001">${attributes.id}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="名称">名称:</span><span class="p_value" title="申请单位审批不通过">${attributes.name}</span>
                                </div>
                            </div>
                         </div>`;
                break;
            case CONSTANTS.LAYER.DEVICE://设备
                content=`<div class="info-middle" style="width: 550px;background-color: #36455C;">
                     <div style="margin-top: 8px;float:left;width: 220px;">
                        <br>
                        <span>探头信息</span><br><br>
                        <span>   状态：${attributes.type==0?'正常':'异常'}</span><br>
                        <span>   实时值：${attributes.value} ${attributes.unit}</span>
                     </div>
                     <div style="margin-top: 8px;">
                         <table border="0" cellspacing="0" cellpadding="0" width="320" style="padding-top: 50px;padding-bottom: 20px;">
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;width: 30%;">监测点ID：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.tagId}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">监测点名称：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.tagName}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">更新时间：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.updateTime}</td></tr>
                            <tr style="height: 40px"><td style="border: 1px solid #465773;background-color: #253D61;">报警状态：</td><td style="border: 1px solid #465773;background-color: #20304A;">${attributes.type==0?'正常':'异常'}</td></tr>
                         </table>
                     </div>
                </div>`;
                break;
            case CONSTANTS.LAYER.WORKPERMIT://作业票
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">${attributes.permitTypeName}</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    <span class="p_label" title="编号">编号:</span><span class="p_value">${attributes.no}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="状态">状态:</span><span class="p_value">${attributes.status}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="作业级别">作业级别:</span><span class="p_value">${attributes.riskGrade}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="动火方式">动火方式:</span><span class="p_value"><span style="margin-right:5px;">电焊</span><span style="margin-right:5px;">电钻</span></span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="动火内容">动火内容:</span><span class="p_value">${attributes.name}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="作业开始时间">作业开始时间:</span><span class="p_value">${attributes.actualStartTime}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="作业结束时间">作业结束时间:</span><span class="p_value">${attributes.actualEndTime||""}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label" title="所属风险区域">所属风险区域:</span><span class="p_value">${attributes.place}</span>
                                </div>
                            </div>
                         </div>`;
                break;
            case CONSTANTS.LAYER.STORE://仓库物资
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">仓库物资</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    <span class="p_label">名称:</span><span class="p_value">${attributes.name}</span>
                                </div>
                                <div class="p_line">
                                    <span class="p_label">物资:</span><span class="p_value">${attributes.suppliesClassifyVo.classifyName}</span>
                                </div>
                            </div>
                         </div>`;
                break;
            default:
                content=`<div class="pop_div">
                            <div class="head1">
                                <span class="title">暂无数据</span>
                            </div>
                            <div class="content1">
                                <div class="p_line">
                                    暂无数据
                                </div>
                            </div>
                         </div>`;
        }
        return `
                    <a class="leaflet-popup-close-button" href="javascript:void(0);" style="right: 10px;position: absolute;">×</a>
                    <div class="leaflet-popup-content-wrapper">
                        <div class="leaflet-popup-content">
                            ${content}
                        </div>
                    </div>
                    ${bottomBtn}
                `;
    },
    /**
     * 添加图层
     * @param {*} layer
     */
    addLayer(layer){
        if(!this.layerMap){
            this.layerMap=new Map();
        }
        let name=layer.layerName || layer.get("layerName");
        this.layerMap.set(name,layer);
    },
    /**
     * 获取图层
     * @param {*} name
     */
    getLayerByName(name){
        if(this.layerMap){
            return this.layerMap.get(name);
        }
        return null;
    },

    /**
     * 删除图层
     * @param {*} layer
     */
    removeLayer(layer){
        window.viewer.dataSources.remove(layer.dataSource);
    },


    /**
     * 加载模型
     * @param {*} modelInfo id=geokey,name,address,token,companyId
     * let geoKey = temp[0];//geoKey=id
     * let token = temp[1];//token
     * let companyId = temp[2];//companyId
     * let address = temp[3];
     */
    change3DModel(modelInfo){
        let self=this;
        let tileset = window.viewer._tilesetModels.filter(obj=> obj._id === modelInfo.id);
        if(tileset.length === 0){//判断是不是存在
          const obj = {
            id: modelInfo.id,
            name: modelInfo.name,
            key:modelInfo.key,
            type:modelInfo.type||'tileset',
            url: "http://"+modelInfo.address+"/assets/"+ modelInfo.id+"/tileset.json",
            authorization: {
              token: modelInfo.token,
              companyId: modelInfo.companyId
            }
          }
          self.viewer.addTileset(obj);
        }else{
          self.viewer.flyTo(tileset[0]);
        }
    },

    /**
     * 通过id获取模型
     * @param {*} id
     */
    getModelById(id){
        let tileset = window.viewer._tilesetModels.filter(obj=> obj._id === id);
        if(tileset.length === 0){
            return tileset[0];
        }
        return null;
    },

    /**
     * camera飞行到指定坐标与高度
     * @param {*} lon
     * @param {*} lat
     * @param {*} alt
     * @param {*} heading 指向
     * @param {*} pitch 视角
     */
    flyTo(lon, lat,alt=500,heading=0.0,pitch=-60,roll=0){
        //定位
        window.viewer.camera.flyTo({
          destination : Cesium.Cartesian3.fromDegrees(Number(lon), Number(lat),Number(alt)),
          orientation : {
            heading : Cesium.Math.toRadians(heading),// 指向
            pitch : Cesium.Math.toRadians(pitch),// 视角
            roll : roll
          }
        });
    },

    /**
     * 飞行到指定实体
     * @param {*} entity
     * @param {*} pitch  视角
     * @param {*} range 距中心的距离，以米为单位
     */
    flyToByEntity(entity,pitch=-90.0,range=0){
        if(entity){
            window.viewer.flyTo(entity, {
                duration: 3,
                offset: new Cesium.HeadingPitchRange(0.0, Cesium.Math.toRadians(pitch),range)
            });
        }
    },

    /**
     * 高亮实体
     * @param {*} entity
     */
    highLightByEntity(entity){
        if(entity&&entity.attributes){
            switch (entity.attributes.layerName) {
                case CONSTANTS.LAYER.PATROLASSET+"_road"://巡查道路设施
                    entity.polyline.width=entity.attributes.highLightStyle.lineWidth||5;
                    entity.polyline.material.color=Cesium.Color.fromCssColorString(entity.attributes.highLightStyle.strokeStyle);
                    break;
                case CONSTANTS.LAYER.ASSET+"_road"://资产道路设施
                    entity.polyline.width=entity.attributes.highLightStyle.lineWidth||5;
                    entity.polyline.material.color=Cesium.Color.fromCssColorString(entity.attributes.highLightStyle.strokeStyle);
                    break;
                default:

            }
            this.highlightEntity=entity;
        }
    },


    /**
     * 取消高亮
     */
    cancelHighLight(){
        if(this.highlightEntity){
            if(this.highlightEntity.attributes){
                switch (this.highlightEntity.attributes.layerName) {
                    case CONSTANTS.LAYER.PATROLASSET+"_road"://巡查道路设施
                        this.highlightEntity.polyline.width=this.highlightEntity.attributes.normalStyle.lineWidth||5;
                        this.highlightEntity.polyline.material.color=Cesium.Color.fromCssColorString(this.highlightEntity.attributes.normalStyle.strokeStyle);
                        break;
                    case CONSTANTS.LAYER.ASSET+"_road"://资产道路设施
                        this.highlightEntity.polyline.width=this.highlightEntity.attributes.normalStyle.lineWidth||5;
                        this.highlightEntity.polyline.material.color=Cesium.Color.fromCssColorString(this.highlightEntity.attributes.normalStyle.strokeStyle);
                        break;
                    default:

                }
                this.highlightEntity=null;
            }
        }
    }
};
